/**
 * Title 컴포넌트
 * https://www.figma.com/file/TJGOBLk3lZBBvLnrdThGqs/MobileApp-UI-Component?node-id=338%3A313
 */

import Headline from './Headline';
import Section from './Section';
import SubHeader from './SubHeader';

export default {
  Section,
  Headline,
  SubHeader
};
